import { useParams, useNavigate } from 'react-router-dom';
import { ExternalUserDetailPage as SharedDetailPage } from '@/features/external-users/views/ExternalUserDetailPage';
import { usePermissions } from '../../../hooks/auth/usePermissions';
import { useConfirmDialog } from '../../../contexts/ConfirmDialogContext';
import { notifications } from '../../../utils/notifications';
import { useAuthStore } from '../../../stores/auth-store';

export const ExternalUserDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { can } = usePermissions();
  const { confirm } = useConfirmDialog();
  const { logout } = useAuthStore();

  if (!id) return null;

  const handleConfirmAction = async (opts: { title: string; message: string; confirmLabel: string; variant: 'danger' | 'warning' | 'info' }) => {
    return confirm({
      title: opts.title,
      message: opts.message,
      confirmLabel: opts.confirmLabel,
      variant: opts.variant,
    });
  };

  const handleLogout = () => {
    logout();
    navigate('/login', { state: { message: 'Mot de passe modifié. Veuillez vous reconnecter.' } });
  };

  return (
    <div className="tw-pt-4">
      <SharedDetailPage
        embedded
        userId={id}
        notify={{
          success: notifications.success,
          error: notifications.error,
        }}
        onNavigate={(path) => navigate(path)}
        basePath="/users-externes"
        permissions={{
          canEditPersonalInfo: can('external_user.edit_personal_info'),
          canEditPermissions: can('external_user.edit_permissions'),
          canEditPassword: can('external_user.edit_password'),
          canEditSocieties: can('external_user.edit_societies'),
          canResendWelcomeEmail: can('external_user.resend_welcome_email'),
          canImpersonate: false,
          canDelete: can('external_user.delete'),
          canViewAuditLogs: can('external_user.view_audit_logs'),
        }}
        confirmAction={handleConfirmAction}
        onLogout={handleLogout}
      />
    </div>
  );
};
